<template lang="jade">
div.Form__group(":tooltip.sync"="fdata.tip")
  h2.Form__heading(v-bind:class="{'Form__heading--required': required}") {{ fdata.label }}
  div.Rad-group
    div.Rad-group__item(v-for="opt in fdata.options")
      div.Rad
        div.Rad__label {{ opt.label }}
        label.Rad__control
          input.Rad__field(":name"="fdata.field"
                             type="radio"
                             ":value"="opt.value"
                             ":checked"="opt.checked"
                             ":disabled"="!fdata.editable"
                             v-model="formInput"
                             @change="checked")
          div.Rad__indicator
</template>

<script>
  import _ from 'lodash'
  import input from 'src/components/inputs/dynamic/input'
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: '',
        show: false
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          val.options.filter(el => {
            if (val.editable === false) {
              val.field = false
            }
            el.checked = val.value === el.code
            return el
          })
          return val
        }
      }
    },
    computed: {
      input () {
        return {
          type: 'text',
          label: this.fdata.label,
          required: true
        }
      },
      display () {
        if (!this.formInput) return `Select ${this.fdata.label}...`
        return _.get(_.find(this.fdata.options, ['value', this.formInput]), 'label')
      },
      callbacks () {
        return {
          focus: this.focus,
          blur: this.clickAway
        }
      }
    },
    components: {
      'dynamic-input': input
    },
    methods: {
      clickAway (e) {
        this.$set('show', false)
      },
      checked () {
        this.$set('show', false)
        this.validate()
      },

      validate () {
        let validated = this.computedValidate(this.fdata,
                                              this.formInput)
        this.notice('error', validated)
      },

      notice (type, valid) {
        _.isNil(valid) || _.isEmpty(valid)
          ? this.removeNotification(this.fdata.field)
          : this.addNotification({
            type: type,
            msg: valid,
            id: this.fdata.field,
            show: this.attempts > 0
          })

        // if (this.fdata.field) {
        this.$dispatch('fdata::input', {
          [this.fdata.field]: this.formInput
        })
        // }
      },

      focus () {
        this.$set('show', true)
      }
    },
    ready () {
      this.formInput = this.fdata.value
    }
  }
</script>



// WEBPACK FOOTER //
// radio.vue?39fb3622